import { Check } from "lucide-react";
import { Text } from "../../../../../core";

const StepIndicator = ({
  currentStep,
  steps,
}: {
  currentStep: number;
  steps: { title: string; description: string }[];
}) => {
  return (
    <div className="flex flex-wrap gap-2 w-full justify-center">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`
                        flex items-center px-4 py-2 rounded-full text-sm
                        transition-colors duration-200
                        ${
                          index + 1 === currentStep
                            ? "bg-indigo-600 dark:bg-primary-500 text-white shadow-md"
                            : index + 1 < currentStep
                              ? "bg-indigo-100 dark:bg-indigo-900 text-indigo-700 dark:text-indigo-200"
                              : "bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400"
                        }
                    `}
        >
          <div className="flex items-center space-x-2">
            <Text
              variant="span"
              className={`
                            w-5 h-5 rounded-full flex items-center justify-center text-xs
                            ${
                              index + 1 === currentStep
                                ? "bg-white dark:bg-gray-800 text-indigo-600 dark:text-indigo-400"
                                : index + 1 < currentStep
                                  ? "bg-indigo-200 dark:bg-indigo-800 text-indigo-700 dark:text-indigo-200"
                                  : "bg-gray-200 dark:bg-gray-700 text-gray-600 dark:text-gray-400"
                            }
                        `}
            >
              {index + 1 < currentStep ? (
                <Check className="w-3 h-3" />
              ) : (
                <Text variant="span">{index + 1}</Text>
              )}
            </Text>
            <span className="hidden sm:inline">{step.title}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StepIndicator;
